/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserSecurityClearanceCreateRequest,
  UserSecurityClearanceListResponse,
  UserSecurityClearanceResponse,
  UserSecurityClearanceUpdateRequest,
} from '../models/index';
import {
    UserSecurityClearanceCreateRequestFromJSON,
    UserSecurityClearanceCreateRequestToJSON,
    UserSecurityClearanceListResponseFromJSON,
    UserSecurityClearanceListResponseToJSON,
    UserSecurityClearanceResponseFromJSON,
    UserSecurityClearanceResponseToJSON,
    UserSecurityClearanceUpdateRequestFromJSON,
    UserSecurityClearanceUpdateRequestToJSON,
} from '../models/index';

export interface AssignDefaultClearanceRequest {
    userId: string;
    targetTenantId: string;
    sessionId?: string;
}

export interface BulkGrantClearanceRequest {
    userIds: Array<string>;
    targetTenantId: string;
    userSecurityClearanceCreateRequest: UserSecurityClearanceCreateRequest;
    sessionId?: string;
}

export interface BulkRevokeClearanceRequest {
    userIds: Array<string>;
    targetTenantId: string;
    sessionId?: string;
}

export interface ExtendClearanceRequest {
    userId: string;
    targetTenantId: string;
    newExpirationDate: Date;
    sessionId?: string;
}

export interface GetClearanceRequest {
    userId: string;
    targetTenantId: string;
    sessionId?: string;
}

export interface GetClearancesExpiringSoonRequest {
    sessionId?: string;
    days?: number;
    page?: number;
    pageSize?: number;
}

export interface GetExpiredClearancesRequest {
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GetTenantClearancesRequest {
    targetTenantId: string;
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GetUserClearancesRequest {
    userId: string;
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GrantClearanceRequest {
    userId: string;
    targetTenantId: string;
    userSecurityClearanceCreateRequest: UserSecurityClearanceCreateRequest;
    sessionId?: string;
}

export interface RevokeClearanceRequest {
    userId: string;
    targetTenantId: string;
    sessionId?: string;
}

export interface UpdateClearanceRequest {
    userId: string;
    targetTenantId: string;
    userSecurityClearanceUpdateRequest: UserSecurityClearanceUpdateRequest;
    sessionId?: string;
}

export interface ValidateCrossTenantAccessRequest {
    userId: string;
    sourceTenantId: string;
    targetTenantId: string;
    resourceType: string;
    resourceId: string;
    resourceSecurityLevel: number;
    operation: string;
    sessionId?: string;
}

/**
 * UserSecurityClearancesApi - interface
 * 
 * @export
 * @interface UserSecurityClearancesApiInterface
 */
export interface UserSecurityClearancesApiInterface {
    /**
     * Assigns the default (minimum) security clearance to a user for a specific tenant.
     * @summary Assign default security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    assignDefaultClearanceRaw(requestParameters: AssignDefaultClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Assigns the default (minimum) security clearance to a user for a specific tenant.
     * Assign default security clearance
     */
    assignDefaultClearance(requestParameters: AssignDefaultClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Grants security clearance to multiple users for a specific tenant with the specified maximum security level.
     * @summary Bulk grant security clearance
     * @param {Array<string>} userIds List of user IDs
     * @param {string} targetTenantId Target tenant ID
     * @param {UserSecurityClearanceCreateRequest} userSecurityClearanceCreateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    bulkGrantClearanceRaw(requestParameters: BulkGrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Grants security clearance to multiple users for a specific tenant with the specified maximum security level.
     * Bulk grant security clearance
     */
    bulkGrantClearance(requestParameters: BulkGrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Revokes security clearance from multiple users for a specific tenant.
     * @summary Bulk revoke security clearance
     * @param {Array<string>} userIds List of user IDs
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    bulkRevokeClearanceRaw(requestParameters: BulkRevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Revokes security clearance from multiple users for a specific tenant.
     * Bulk revoke security clearance
     */
    bulkRevokeClearance(requestParameters: BulkRevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Extends the expiration date of a user\'s security clearance for a specific tenant.
     * @summary Extend security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {Date} newExpirationDate New expiration date
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    extendClearanceRaw(requestParameters: ExtendClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Extends the expiration date of a user\'s security clearance for a specific tenant.
     * Extend security clearance
     */
    extendClearance(requestParameters: ExtendClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Retrieves the security clearance for a user in a specific tenant.
     * @summary Get user security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    getClearanceRaw(requestParameters: GetClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Retrieves the security clearance for a user in a specific tenant.
     * Get user security clearance
     */
    getClearance(requestParameters: GetClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Retrieves security clearances that will expire within the specified number of days with pagination.
     * @summary Get clearances expiring soon
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [days] Number of days
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    getClearancesExpiringSoonRaw(requestParameters: GetClearancesExpiringSoonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>>;

    /**
     * Retrieves security clearances that will expire within the specified number of days with pagination.
     * Get clearances expiring soon
     */
    getClearancesExpiringSoon(requestParameters: GetClearancesExpiringSoonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse>;

    /**
     * Retrieves all expired security clearances for the current tenant with pagination.
     * @summary Get expired security clearances
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    getExpiredClearancesRaw(requestParameters: GetExpiredClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>>;

    /**
     * Retrieves all expired security clearances for the current tenant with pagination.
     * Get expired security clearances
     */
    getExpiredClearances(requestParameters: GetExpiredClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse>;

    /**
     * Retrieves all security clearances for a specific tenant with pagination.
     * @summary Get tenant security clearances
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    getTenantClearancesRaw(requestParameters: GetTenantClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>>;

    /**
     * Retrieves all security clearances for a specific tenant with pagination.
     * Get tenant security clearances
     */
    getTenantClearances(requestParameters: GetTenantClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse>;

    /**
     * Retrieves all security clearances for a user across all accessible tenants with pagination.
     * @summary Get all user security clearances
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    getUserClearancesRaw(requestParameters: GetUserClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>>;

    /**
     * Retrieves all security clearances for a user across all accessible tenants with pagination.
     * Get all user security clearances
     */
    getUserClearances(requestParameters: GetUserClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse>;

    /**
     * Grants security clearance to a user for a specific tenant with the specified maximum security level.
     * @summary Grant security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {UserSecurityClearanceCreateRequest} userSecurityClearanceCreateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    grantClearanceRaw(requestParameters: GrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Grants security clearance to a user for a specific tenant with the specified maximum security level.
     * Grant security clearance
     */
    grantClearance(requestParameters: GrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Revokes security clearance from a user for a specific tenant (soft delete).
     * @summary Revoke security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    revokeClearanceRaw(requestParameters: RevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Revokes security clearance from a user for a specific tenant (soft delete).
     * Revoke security clearance
     */
    revokeClearance(requestParameters: RevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Updates the security clearance for a user in a specific tenant.
     * @summary Update security clearance
     * @param {string} userId User ID
     * @param {string} targetTenantId Target tenant ID
     * @param {UserSecurityClearanceUpdateRequest} userSecurityClearanceUpdateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    updateClearanceRaw(requestParameters: UpdateClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>>;

    /**
     * Updates the security clearance for a user in a specific tenant.
     * Update security clearance
     */
    updateClearance(requestParameters: UpdateClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse>;

    /**
     * Validates whether a user can access a resource in a target tenant based on their security clearance.
     * @summary Validate cross-tenant access
     * @param {string} userId User ID
     * @param {string} sourceTenantId Source tenant ID
     * @param {string} targetTenantId Target tenant ID
     * @param {string} resourceType Resource type
     * @param {string} resourceId Resource ID
     * @param {number} resourceSecurityLevel Resource security level
     * @param {string} operation Operation type
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecurityClearancesApiInterface
     */
    validateCrossTenantAccessRaw(requestParameters: ValidateCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validates whether a user can access a resource in a target tenant based on their security clearance.
     * Validate cross-tenant access
     */
    validateCrossTenantAccess(requestParameters: ValidateCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class UserSecurityClearancesApi extends runtime.BaseAPI implements UserSecurityClearancesApiInterface {

    /**
     * Assigns the default (minimum) security clearance to a user for a specific tenant.
     * Assign default security clearance
     */
    async assignDefaultClearanceRaw(requestParameters: AssignDefaultClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling assignDefaultClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling assignDefaultClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/assign-default`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Assigns the default (minimum) security clearance to a user for a specific tenant.
     * Assign default security clearance
     */
    async assignDefaultClearance(requestParameters: AssignDefaultClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.assignDefaultClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grants security clearance to multiple users for a specific tenant with the specified maximum security level.
     * Bulk grant security clearance
     */
    async bulkGrantClearanceRaw(requestParameters: BulkGrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userIds'] == null) {
            throw new runtime.RequiredError(
                'userIds',
                'Required parameter "userIds" was null or undefined when calling bulkGrantClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling bulkGrantClearance().'
            );
        }

        if (requestParameters['userSecurityClearanceCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'userSecurityClearanceCreateRequest',
                'Required parameter "userSecurityClearanceCreateRequest" was null or undefined when calling bulkGrantClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['userIds'] = requestParameters['userIds'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/bulk-grant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSecurityClearanceCreateRequestToJSON(requestParameters['userSecurityClearanceCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Grants security clearance to multiple users for a specific tenant with the specified maximum security level.
     * Bulk grant security clearance
     */
    async bulkGrantClearance(requestParameters: BulkGrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.bulkGrantClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes security clearance from multiple users for a specific tenant.
     * Bulk revoke security clearance
     */
    async bulkRevokeClearanceRaw(requestParameters: BulkRevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userIds'] == null) {
            throw new runtime.RequiredError(
                'userIds',
                'Required parameter "userIds" was null or undefined when calling bulkRevokeClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling bulkRevokeClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['userIds'] = requestParameters['userIds'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/bulk-revoke`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Revokes security clearance from multiple users for a specific tenant.
     * Bulk revoke security clearance
     */
    async bulkRevokeClearance(requestParameters: BulkRevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.bulkRevokeClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extends the expiration date of a user\'s security clearance for a specific tenant.
     * Extend security clearance
     */
    async extendClearanceRaw(requestParameters: ExtendClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling extendClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling extendClearance().'
            );
        }

        if (requestParameters['newExpirationDate'] == null) {
            throw new runtime.RequiredError(
                'newExpirationDate',
                'Required parameter "newExpirationDate" was null or undefined when calling extendClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        if (requestParameters['newExpirationDate'] != null) {
            queryParameters['newExpirationDate'] = (requestParameters['newExpirationDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/extend`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Extends the expiration date of a user\'s security clearance for a specific tenant.
     * Extend security clearance
     */
    async extendClearance(requestParameters: ExtendClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.extendClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the security clearance for a user in a specific tenant.
     * Get user security clearance
     */
    async getClearanceRaw(requestParameters: GetClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling getClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/user/{userId}/tenant/{targetTenantId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"targetTenantId"}}`, encodeURIComponent(String(requestParameters['targetTenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the security clearance for a user in a specific tenant.
     * Get user security clearance
     */
    async getClearance(requestParameters: GetClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.getClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves security clearances that will expire within the specified number of days with pagination.
     * Get clearances expiring soon
     */
    async getClearancesExpiringSoonRaw(requestParameters: GetClearancesExpiringSoonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/expiring-soon`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves security clearances that will expire within the specified number of days with pagination.
     * Get clearances expiring soon
     */
    async getClearancesExpiringSoon(requestParameters: GetClearancesExpiringSoonRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse> {
        const response = await this.getClearancesExpiringSoonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all expired security clearances for the current tenant with pagination.
     * Get expired security clearances
     */
    async getExpiredClearancesRaw(requestParameters: GetExpiredClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/expired`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all expired security clearances for the current tenant with pagination.
     * Get expired security clearances
     */
    async getExpiredClearances(requestParameters: GetExpiredClearancesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse> {
        const response = await this.getExpiredClearancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security clearances for a specific tenant with pagination.
     * Get tenant security clearances
     */
    async getTenantClearancesRaw(requestParameters: GetTenantClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>> {
        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling getTenantClearances().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/tenant/{targetTenantId}`;
        urlPath = urlPath.replace(`{${"targetTenantId"}}`, encodeURIComponent(String(requestParameters['targetTenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security clearances for a specific tenant with pagination.
     * Get tenant security clearances
     */
    async getTenantClearances(requestParameters: GetTenantClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse> {
        const response = await this.getTenantClearancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security clearances for a user across all accessible tenants with pagination.
     * Get all user security clearances
     */
    async getUserClearancesRaw(requestParameters: GetUserClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserClearances().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security clearances for a user across all accessible tenants with pagination.
     * Get all user security clearances
     */
    async getUserClearances(requestParameters: GetUserClearancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceListResponse> {
        const response = await this.getUserClearancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grants security clearance to a user for a specific tenant with the specified maximum security level.
     * Grant security clearance
     */
    async grantClearanceRaw(requestParameters: GrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling grantClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling grantClearance().'
            );
        }

        if (requestParameters['userSecurityClearanceCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'userSecurityClearanceCreateRequest',
                'Required parameter "userSecurityClearanceCreateRequest" was null or undefined when calling grantClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/grant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSecurityClearanceCreateRequestToJSON(requestParameters['userSecurityClearanceCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Grants security clearance to a user for a specific tenant with the specified maximum security level.
     * Grant security clearance
     */
    async grantClearance(requestParameters: GrantClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.grantClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes security clearance from a user for a specific tenant (soft delete).
     * Revoke security clearance
     */
    async revokeClearanceRaw(requestParameters: RevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling revokeClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling revokeClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/revoke`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Revokes security clearance from a user for a specific tenant (soft delete).
     * Revoke security clearance
     */
    async revokeClearance(requestParameters: RevokeClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.revokeClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the security clearance for a user in a specific tenant.
     * Update security clearance
     */
    async updateClearanceRaw(requestParameters: UpdateClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSecurityClearanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateClearance().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling updateClearance().'
            );
        }

        if (requestParameters['userSecurityClearanceUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'userSecurityClearanceUpdateRequest',
                'Required parameter "userSecurityClearanceUpdateRequest" was null or undefined when calling updateClearance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserSecurityClearanceUpdateRequestToJSON(requestParameters['userSecurityClearanceUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSecurityClearanceResponseFromJSON(jsonValue));
    }

    /**
     * Updates the security clearance for a user in a specific tenant.
     * Update security clearance
     */
    async updateClearance(requestParameters: UpdateClearanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSecurityClearanceResponse> {
        const response = await this.updateClearanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates whether a user can access a resource in a target tenant based on their security clearance.
     * Validate cross-tenant access
     */
    async validateCrossTenantAccessRaw(requestParameters: ValidateCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['sourceTenantId'] == null) {
            throw new runtime.RequiredError(
                'sourceTenantId',
                'Required parameter "sourceTenantId" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['targetTenantId'] == null) {
            throw new runtime.RequiredError(
                'targetTenantId',
                'Required parameter "targetTenantId" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['resourceSecurityLevel'] == null) {
            throw new runtime.RequiredError(
                'resourceSecurityLevel',
                'Required parameter "resourceSecurityLevel" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        if (requestParameters['operation'] == null) {
            throw new runtime.RequiredError(
                'operation',
                'Required parameter "operation" was null or undefined when calling validateCrossTenantAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['sourceTenantId'] != null) {
            queryParameters['sourceTenantId'] = requestParameters['sourceTenantId'];
        }

        if (requestParameters['targetTenantId'] != null) {
            queryParameters['targetTenantId'] = requestParameters['targetTenantId'];
        }

        if (requestParameters['resourceType'] != null) {
            queryParameters['resourceType'] = requestParameters['resourceType'];
        }

        if (requestParameters['resourceId'] != null) {
            queryParameters['resourceId'] = requestParameters['resourceId'];
        }

        if (requestParameters['resourceSecurityLevel'] != null) {
            queryParameters['resourceSecurityLevel'] = requestParameters['resourceSecurityLevel'];
        }

        if (requestParameters['operation'] != null) {
            queryParameters['operation'] = requestParameters['operation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-security-clearances/validate-access`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validates whether a user can access a resource in a target tenant based on their security clearance.
     * Validate cross-tenant access
     */
    async validateCrossTenantAccess(requestParameters: ValidateCrossTenantAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateCrossTenantAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
